import { render, staticRenderFns } from "./InlineTaskKanbanListWrapper.vue?vue&type=template&id=07d7d22e&"
import script from "./InlineTaskKanbanListWrapper.vue?vue&type=script&lang=js&"
export * from "./InlineTaskKanbanListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports